import type { Meta } from "../types";

/**
 * Metadados da captura (URL, viewport, DPR, user agent, instante) mais o `contexto` que a
 * aplicação anfitriã declarou (DEV-268).
 *
 * O contexto entra AQUI, e não como campo irmão no payload, porque é da mesma natureza do
 * resto: descreve o AMBIENTE em que o report aconteceu, não o que a pessoa relatou. É por
 * isso que ele desemboca no mesmo bloco "Ambiente" do `contexto.md`, ao lado da página e do
 * navegador.
 */
export function coletarMeta(contexto?: Record<string, string>): Meta {
  return {
    url: location.href,
    viewport: { w: window.innerWidth, h: window.innerHeight },
    dpr: window.devicePixelRatio || 1,
    userAgent: navigator.userAgent,
    timestamp: new Date().toISOString(),
    ...(contexto ? { contexto } : {}),
  };
}
